import { MapErrorPlaceholder } from 'components/Basic/Map/MapErrorPlaceholder';
import { useDomainConfig } from 'context/DomainConfigProvider/DomainConfigProvider';
import { MapContext } from 'context/Map/context';
import { mapReducer } from 'context/Map/reducer';
import { useMapProviderQueryApi } from 'graphql/generated';
import { useComponentUpdate } from 'hooks/helpers/UseComponentUpdate';
import { useReducer } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { DomainConfigType } from 'utils/Domain/Domain';

const DEFAULT_IS_FIT_TO_BOUNDS = true;

type MapProviderProps = {
    children: (provider: string | undefined) => React.ReactNode;
    initSetting?: DomainConfigType['mapSetting'];
};

export const MapProvider = ({ children, initSetting }: MapProviderProps) => {
    const { mapSetting: defaultSetting } = useDomainConfig();
    const [mapProviderResult] = useMapProviderQueryApi();

    const value = useReducer(mapReducer, {
        zoom: initSetting?.zoom ?? defaultSetting.zoom,
        center: {
            lng: initSetting?.longitude ?? defaultSetting.longitude,
            lat: initSetting?.latitude ?? defaultSetting.latitude,
        },
        mapProvider: mapProviderResult.data?.mapProvider,
        isFitToBounds: DEFAULT_IS_FIT_TO_BOUNDS,
        initSetting: initSetting ?? defaultSetting,
    });
    const [, dispatch] = value;

    useComponentUpdate(() => {
        if (mapProviderResult.data?.mapProvider) {
            dispatch({
                type: 'setMapProvider',
                payload: mapProviderResult.data.mapProvider,
            });
        }
    }, [mapProviderResult.data?.mapProvider]);

    return (
        <MapContext.Provider value={value}>
            <ErrorBoundary FallbackComponent={MapErrorPlaceholder}>
                {children(mapProviderResult.data?.mapProvider.provider)}
            </ErrorBoundary>
        </MapContext.Provider>
    );
};
